import * as React from 'react';
import { PreviewMode } from './preview-context';
import { Text, Box, TextButton } from '@wix/design-system';
import { composer } from '../../../component-decorators/composer';
import type { TFunction } from 'i18next';

export interface IDescriptionWrapper {
  description: string;
}

export class DescriptionPreviewWrapper extends React.Component<
  IDescriptionWrapper,
  any
> {
  render() {
    return (
      <PreviewMode.Consumer>
        {(value) => {
          return value.isPreview && !this.props.description ? (
            <Box direction="vertical" marginBottom={3}>
              <Text weight="thin" dataHook="solution-description">
                <TranslatedKey tkey="solution.page.preview.overviewText" />
              </Text>
              <TextButton
                as="a"
                href={`https://dev.wix.com/dc3/my-apps/${value.appId}/market/info/basic-info`}
                target="_blank"
              >
                <TranslatedKey tkey="solution.page.preview.overview.cta" />
              </TextButton>
            </Box>
          ) : (
            this.props.children
          );
        }}
      </PreviewMode.Consumer>
    );
  }
}

const TranslatedKey = composer()
  .withTranslation()
  .compose(({ t, tkey }: { t?: TFunction; tkey: string }) => t(tkey));
